import React, { memo } from 'react';
import { StyleSheet, View, Pressable, Image } from 'react-native';

import ImagePicker from '../form/attachments/image_picker';

const EditAvatarView = memo((props) => {
  function handleRoll() {
    ImagePicker.selectImage().then((result) => {
      props.onSelectImage(result);
    });
  }

  return (
    <View style={styles.container}>
      <View style={styles.profilePictureContainer}>
        {props.children}

        {!props.readOnly && (
          <Pressable style={styles.changePhotoButton} onPress={handleRoll}>
            <Image
              style={styles.changePhotoButtonImage}
              source={require('../../../../resources/edit-circle-large.png')}
              resizeMode="contain"
            />
          </Pressable>
        )}
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    alignItems: 'center',
  },
  profilePictureContainer: {
    paddingBottom: 17,
    paddingRight: 13,
  },
  changePhotoButton: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  changePhotoButtonImage: {
    width: 80,
    height: 80,
    // backgroundColor: 'green'
  },
});

export default EditAvatarView;
